import { render } from "./WaveAnimationBackground.vue?vue&type=template&id=35044f35&scoped=true&ts=true"
import script from "./WaveAnimationBackground.vue?vue&type=script&lang=ts"
export * from "./WaveAnimationBackground.vue?vue&type=script&lang=ts"

import "./WaveAnimationBackground.vue?vue&type=style&index=0&id=35044f35&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35044f35"]])

export default __exports__